import dayjs from 'dayjs';

/**
 * @param {Date} date
 * @returns {String} date with the format 'YYYY-MM-DD'
 */
export function getISOStringWithoutTime(date) {
  return dayjs(date).format('YYYY-MM-DD');
}

/**
 *
 * @param {String} time with the format HH:MM:SS
 * @returns {String} with the format HH:MM
 */
export function formatTime(time) {
  const meridiemTime = time.slice(0, 2) >= 12 ? 'pm' : 'am';
  return `${time.slice(0, 5)} ${meridiemTime}`;
}

/**
 * @param {Date} date
 * @returns {String} "Dom. 8/9"
 */
export function getTextFromDate(date) {
  const _date = new Date(`${date}T00:00`);
  const today = new Date();
  const tomorrow = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() + 1,
  );

  if (getISOStringWithoutTime(_date) === getISOStringWithoutTime(today)) {
    return 'Hoy';
  } else if (
    getISOStringWithoutTime(_date) === getISOStringWithoutTime(tomorrow)
  ) {
    return 'Mañana';
  }
  const weekDay = {
    0: 'Dom.',
    1: 'Lun.',
    2: 'Mar.',
    3: 'Mie.',
    4: 'Jue.',
    5: 'Vie.',
    6: 'Sab.',
  };
  const day = weekDay[_date.getDay()];
  return `${day} ${_date.getDate()}/${_date.getMonth() + 1}`;
}
